<app-template-text
  [counter]="counter"
  [disabled]="disabled"
  [characters]="characters"
  [value]="value"
  [minlength]="minlength"
  [maxlength]="maxlength"
  [control]="control"
  [label]="label"
/>
